import { api } from "./customers";

export const invoicesListApi = api.injectEndpoints({
  endpoints: (build) => ({
    getInvoicesList: build.query<any, any>({
      query: () => `invoices`,
    }),
    getInvoiceDetails: build.query<any, any>({
      query: ({id}) => `viewinvoice/${id}`,
    }),
  }),
});

export const { useGetInvoicesListQuery, useGetInvoiceDetailsQuery } =
  invoicesListApi;
